export default __webpack_public_path__ + "static/media/Elektricitet-MedVind_colour.28757fd3.png";